import type { IconData } from '@stacksjs/iconify-core'

export const verticalAlignBottom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M356.117 316.117L333.49 293.49L272 354.98V56h-32v298.98l-61.49-61.49l-22.627 22.627L256 416.236zM16 464h480v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default verticalAlignBottom
